import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../data/images';
type QuickLinksProps = {
  compact?: boolean;
};
const links = [{
  to: '/portfolio',
  title: 'See The Skills',
  text: 'Check out the skills of our fellow Tattoo Artists.',
  icon: images.iconSkills
}, {
  to: '/book-now',
  title: 'Appointment Request',
  text: 'Are you excited to get Tattooed or Pierced? Get yourself a Tattoo or Piercing, by Requesting to Schedule an Appointment.',
  icon: images.iconSchedule
}, {
  to: '/artists',
  title: 'Meet The Artists',
  text: 'Do you want to know who’s behind the Art? Meet the people behind the skills.',
  icon: images.iconArtists
}];
export function QuickLinks({
  compact = false
}: QuickLinksProps) {
  return <div className="mx-auto grid max-w-[1000px] gap-14 px-6 md:grid-cols-3 md:gap-10" data-id="element-198" data-mp="2815izmwpb72b">
      {links.map(({
      to,
      title,
      text,
      icon
    }) => <Link key={to} to={to} className="group flex flex-col items-center text-center" data-id="element-199" data-mp="2321bd0pfdhe3">
          <div className={`flex items-end justify-center ${compact ? 'h-16' : 'h-[110px]'}`} data-id="element-200" data-mp="24mxfz5t3nqp1">
            <img src={icon} alt="" aria-hidden="true" className={`${compact ? 'max-h-16 w-16' : 'max-h-[110px] w-[124px]'} object-contain transition-transform duration-200 ease-out group-hover:-translate-y-1`} data-id="element-201" data-mp="29f8qf2lguuvu" />
          </div>
          <h3 className="mt-6 max-w-[220px] font-slab text-lg font-bold uppercase leading-[1.25] tracking-[0.2em] group-hover:underline group-hover:underline-offset-8" data-id="element-202" data-mp="2ocr8xn7jwbuu">
            {title}
          </h3>
          {!compact && <p className="mt-5 max-w-[250px] text-sm font-light leading-[1.6] text-ink-muted" data-id="element-203" data-mp="2ed0e1kf2vuu8">{text}</p>}
        </Link>)}
    </div>;
}